import { DatePicker, Form, Button, Input, message, Row, Col, Select, FormInstance, Spin, Alert, Radio } from 'antd';

import * as input from '../Layouts/FormInput.Style';
import { SetStateAction, useCallback, useContext, useEffect, useState } from 'react';
import { validateProfile } from '../../Services/Prescription.service';
import { ValueType } from '../../Pages/Prescription/InterfaceType';
import { DataContext } from '../../Pages/Prescription/PrescriptionForm';
import dayjs from 'dayjs';
import { isNumeric, validateEmail, validatePhoneNumber } from '../../Utils/common';
import { DELIVERY_CONSTANTS } from '../../Utils/constants';

const CustomerDetailForm = ({
  form,
  onFinish,
  setProfileId,
}: {
  form: FormInstance;
  onFinish: any;
  setProfileId: React.Dispatch<SetStateAction<string>>;
}) => {
  const { initialData, prescriptData } = useContext(DataContext);
  const formatDate = 'YYYY-MM-DD';
  const { Option } = Select;
  const [genders, setGenders] = useState<ValueType[]>([]);
  const [nations, setNations] = useState<ValueType[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isDisplayForm, setIsDisplayForm] = useState(true);
  const [isDisplayFindForm, setIsDisplayFindForm] = useState(false);
  const [isRequireForm, setIsRequireForm] = useState(true);
  const [btnValidType, setBtnValidType] = useState('VALID');
  const [isDisplayBtn, setIsDisplayBtn] = useState(false);
  const [isBtnHidden, setIsBtnHidden] = useState(false);
  const [action, setAction] = useState('EXISTING');
  const [, setValidProfileId] = useState('');
  const [selectedValue, setSelectedValue] = useState('citizen_id');
  const [defaultMemberInfo, setDefaultMemberInfo] = useState<{ fullname: string; phone: string } | null>(null);
  const deliveryTypeWatch = Form.useWatch('delivery_type', form);

  useEffect(() => {
    if (defaultMemberInfo && deliveryTypeWatch === DELIVERY_CONSTANTS.DELIVERY.PICK_UP) {
      form.setFieldsValue({
        delivery_fullname: defaultMemberInfo.fullname,
        delivery_phone_number: defaultMemberInfo.phone,
      });
    }
  }, [deliveryTypeWatch, defaultMemberInfo, form]);

  const getConfig = useCallback(() => {
    if (initialData === undefined) {
      return;
    }
    setGenders(initialData.genders);
    setNations(initialData.nations);
  }, [initialData]);

  useEffect(() => {
    if (
      prescriptData &&
      prescriptData.personal_info.action !== 'NEW' &&
      prescriptData.created_by_source !== 'PARTNER-API'
    ) {
      getValidateProfile();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prescriptData]);

  useEffect(() => {
    getConfig();
    if (prescriptData === undefined) {
      return;
    } else {
      if (prescriptData.status === 'DRAFT' || prescriptData.status === 'REJECT') {
        setIsDisplayBtn(false);
        setIsBtnHidden(false);
      } else {
        setIsDisplayBtn(false);
        setIsBtnHidden(true);
      }
      if (prescriptData.personal_info.display_type === 'VIEW') {
        setIsDisplayForm(true);
        setIsDisplayFindForm(true);
        setIsRequireForm(false);
      } else if (prescriptData.personal_info.display_type === 'EDIT') {
        setIsDisplayForm(false);
        setIsDisplayFindForm(false);
        setIsRequireForm(true);
      }
    }
    const personalInfo = prescriptData?.personal_info || {};
    const newValue = personalInfo.passport_id ? 'passport_id' : 'citizen_id';
    const citizenIdPassportId = personalInfo.citizen_id || personalInfo.passport_id || '';

    setSelectedValue(newValue);
    form.setFieldsValue({
      phone_number: personalInfo.phone_number,
      date_of_birth: dayjs(personalInfo.date_of_birth, formatDate),
      citizen_id_passport_id: citizenIdPassportId,
      citizen_id: personalInfo.citizen_id,
      passport_id: personalInfo.passport_id,
      first_name: personalInfo.first_name,
      last_name: personalInfo.last_name,
      gender: personalInfo.gender,
      congenital_disease: personalInfo.congenital_disease,
      drug_allergy: personalInfo.drug_allergy,
      nation: personalInfo.nation,
      weight: personalInfo.weight,
      height: personalInfo.height,
      email: personalInfo.email,
      profile_address: personalInfo.address,
      profile_zip_code: personalInfo.zip_code,
      button_action: personalInfo.action,
    });
  }, [prescriptData, initialData, form, getConfig]);

  useEffect(() => {
    form.setFieldsValue({
      button_action: action,
    });
  }, [action, form]);

  const getValidateProfile = async () => {
    setIsLoading(true);
    if (btnValidType === 'VALID') {
      let phone_number = '';
      let date_of_birth = '';

      try {
        phone_number = String(form.getFieldValue('phone_number') ?? '').trim();

        const dob = form.getFieldValue('date_of_birth');
        date_of_birth = dob && typeof dob.format === 'function' ? dob.format(formatDate) : '';
      } catch (error) {
        console.error('Error during profile validation:', error);
        message.error('กรุณากรอกข้อมูลใหม่');
        setIsLoading(false);
        return;
      }

      if (!phone_number || !date_of_birth) {
        setIsLoading(false);
        return;
      }

      const dataProfile = {
        phone_number,
        date_of_birth,
      };

      if (!dataProfile.phone_number || !dataProfile.date_of_birth) {
        setIsLoading(false);
        return;
      }

      const res = await validateProfile(dataProfile);
      setIsLoading(false);

      if (res.res_code === '000') {
        const data = res.datas;
        const newValue = data.passport_id ? 'passport_id' : 'citizen_id';
        const citizenId = data.citizen_id !== '0' ? data.citizen_id : '';
        const passportId = data.passport_id !== null ? data.passport_id : '';
        setSelectedValue(newValue);
        form.setFieldsValue({
          citizen_id_passport_id: citizenId || passportId,
          passport_id: passportId,
          citizen_id: citizenId,
          first_name: data.first_name,
          last_name: data.last_name,
          gender: data.gender,
          congenital_disease: data.congenital_disease,
          drug_allergy: data.drug_allergy,
          nation: data.nation,
          weight: data.weight,
          height: data.height,
          email: data.email,
        });
        setProfileId(res.datas.profile_id);
        setValidProfileId(res.datas.profile_id);
        setAction('EXISTING');
        setBtnValidType('CLEAR');
        setIsRequireForm(false);
        setIsDisplayFindForm(true);

        if (data.is_use_default_member) {
          setDefaultMemberInfo({
            fullname: `${data.first_name || ''} ${data.last_name || ''}`.trim(),
            phone: phone_number,
          });
        }
      } else if (res.res_code === 'E101') {
        message.error('ไม่มีข้อมูลในระบบ กรุณากรอกข้อมูลใหม่', 10);
      } else if (res.res_code === 'E102') {
        message.error(
          'ตรวจสอบข้อมูลไม่สำเร็จ ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบข้อมูลอีกครั้ง หรือ ติดต่อ Call Center: 02-538-2229',
          10,
        );
      }
    } else if (btnValidType === 'CLEAR') {
      setIsLoading(false);
      form.resetFields();
      setBtnValidType('VALID');
      setIsRequireForm(true);
      setIsDisplayFindForm(false);
    }
    setIsDisplayForm(true);
  };

  const onInputNewValue = (data: any) => {
    setAction('NEW');
    setIsRequireForm(true);
    setBtnValidType('VALID');
    setIsDisplayForm(false);
    setIsDisplayFindForm(false);

    form.setFieldsValue({
      phone_number: '',
      date_of_birth: '',
      citizen_id_passport_id: '',
      citizen_id: '',
      passport_id: '',
      first_name: '',
      last_name: '',
      gender: '',
      congenital_disease: '',
      drug_allergy: '',
      nation: 'TH',
      weight: '',
      height: '',
      email: '',
      button_action: 'NEW',
    });
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const charCode = event.key;
    if (!charCode.match(/^[0-9]+$/)) {
      event.preventDefault();
    }
  };

  const onChangeCitizenIdPassportId = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (form.getFieldValue('citizen_id')) {
      form.setFieldsValue({
        citizen_id: e.target.value,
        passport_id: null,
      });
    } else {
      form.setFieldsValue({
        citizen_id: null,
        passport_id: e.target.value,
      });
    }
  };

  const onChangeRadio = (e: any) => {
    setSelectedValue(e.target.value);

    if (e.target.value === 'citizen_id') {
      form.setFieldsValue({
        citizen_id: form.getFieldValue('citizen_id_passport_id'),
        passport_id: null,
      });
    } else {
      form.setFieldsValue({
        citizen_id: null,
        passport_id: form.getFieldValue('citizen_id_passport_id'),
      });
    }
  };

  return (
    <div>
      <Spin spinning={isLoading}>
        {/* <AlertModal></AlertModal> */}
        <Row>
          <input.tittle style={{ fontSize: 20, marginBottom: 20 }}>ข้อมูลลูกค้า</input.tittle>
        </Row>
        <Form layout="vertical" form={form} onFinish={onFinish} disabled={isDisplayForm}>
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                {...isNumeric}
                label="เบอร์โทรศัพท์"
                name="phone_number"
                rules={[
                  ...(isNumeric?.rules || []),
                  {
                    validator: (_, value) => {
                      const result = validatePhoneNumber(value);

                      if (!result.isValid) {
                        return Promise.reject(new Error(result.message));
                      }

                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input onKeyPress={handleKeyPress} maxLength={10} disabled={isDisplayFindForm} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={'วัน เดือน ปี เกิด'} name="date_of_birth" rules={[{ required: isRequireForm }]}>
                <DatePicker style={{ display: 'flex' }} format={formatDate} disabled={isDisplayFindForm} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={' '} name={'button_action'}>
                <Row>
                  {!isBtnHidden ? (
                    <Button
                      type="primary"
                      onClick={getValidateProfile}
                      style={{
                        backgroundColor: btnValidType === 'CLEAR' ? '#6B6B6B' : '#50B0E9',
                        width: 130,
                        color: 'white',
                        margin: '0 10px',
                      }}
                      disabled={false}
                      hidden={isDisplayBtn}
                    >
                      {btnValidType === 'CLEAR' ? 'ล้างข้อมูล' : 'ตรวจสอบข้อมูล'}
                    </Button>
                  ) : null}
                  {!isBtnHidden ? (
                    <Button
                      type="primary"
                      style={{
                        backgroundColor: '#78A500',
                        justifyContent: 'center',
                        color: 'white',
                        margin: '0 10px',
                      }}
                      onClick={onInputNewValue}
                      disabled={false}
                      hidden={isDisplayBtn}
                    >
                      กรอกข้อมูลใหม่
                    </Button>
                  ) : null}
                </Row>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={8}>
              <Radio.Group
                name={'radio_citizen_id_passport_id'}
                value={selectedValue}
                onChange={onChangeRadio}
                style={{
                  display: 'horizontal',
                  textAlign: 'left',
                  width: '100%',
                }}
              >
                <Radio value={'citizen_id'}>
                  <input.tittle>เลขที่บัตรประชาชน</input.tittle>
                </Radio>
                <Radio value={'passport_id'}>
                  <input.tittle>เลขหนังสือเดินทาง</input.tittle>
                </Radio>
              </Radio.Group>
            </Col>
            <Col span={8}>
              <Form.Item name={'citizen_id'} hidden={true}>
                <Input />
              </Form.Item>
              <Form.Item name={'passport_id'} hidden={true}>
                <Input />
              </Form.Item>
              <Form.Item label="เลขที่บัตรประชาชน หรือ เลขหนังสือเดินทาง" name="citizen_id_passport_id">
                <Input
                  value={
                    selectedValue === 'citizen_id'
                      ? form.getFieldValue('citizen_id')
                      : form.getFieldValue('passport_id')
                  }
                  onChange={onChangeCitizenIdPassportId}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Alert
                message="หากตรวจสอบข้อมูล แล้วพบว่า ชื่อ-นามสกุล หรือข้อมูลอื่นๆ ไม่ถูกต้อง กรุณาติดต่อ Call Center: 02-538-2229"
                type="warning"
              />
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item label={'ชื่อ'} name={'first_name'} rules={[{ required: isRequireForm }]}>
                <Input maxLength={100} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={'นามสกุล'} name={'last_name'} rules={[{ required: isRequireForm }]}>
                <Input maxLength={100} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={'เพศกำเนิด'}
                className="left-align"
                name={'gender'}
                rules={[{ required: isRequireForm }]}
              >
                <Select placeholder="เลือก">
                  {genders.map((gender) => (
                    <Option key={gender.value} value={gender.key}>
                      {gender.value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item label={'โรคประจำตัว'} name={'congenital_disease'} rules={[{ required: isRequireForm }]}>
                <Input maxLength={100} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={'แพ้ยา'} name={'drug_allergy'} rules={[{ required: isRequireForm }]}>
                <Input maxLength={100} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={'สัญชาติ'} name={'nation'} className="left-align">
                <Select showSearch placeholder="เลือก">
                  {nations.map((e) => (
                    <Option key={e.value} value={e.key}>
                      {e.value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item label={'น้ำหนัก (กิโลกรัม)'} name={'weight'}>
                <Input maxLength={3} placeholder="0" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={'ส่วนสูง (เซนติเมตร)'} name={'height'}>
                <Input maxLength={3} placeholder="0" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...validateEmail} label={'อีเมล'} name={'email'}>
                <Input maxLength={250} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>
    </div>
  );
};

export default CustomerDetailForm;
